import { Link } from "react-router-dom";
import { Brain, Zap, Puzzle, ChevronRight } from "lucide-react";
import { useSkill } from "./SkillShell";

const TILES = [
  ["memory", "/spiele/memory", "Memory", "8 Paare – so wenig Züge wie möglich", Brain, "from-pink-400 to-rose-600"],
  ["reaction", "/spiele/reaktion", "Reaktions-Challenge", "Wie schnell bist du wirklich?", Zap, "from-amber-300 to-orange-500"],
  ["puzzle", "/spiele/puzzle", "Tages-Puzzle", "Jeden Tag ein neues Schiebe-Puzzle", Puzzle, "from-fuchsia-400 to-pink-600"],
];

export function SkillTiles() {
  const { ov } = useSkill();
  if (ov?.blocked) return null;
  return (
    <section className="space-y-3" data-testid="skill-tiles">
      <div className="flex items-end justify-between">
        <div>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-rose-500">Neu · Können zählt</p>
          <h2 className="font-display text-xl font-extrabold">Skill-Spiele</h2>
        </div>
      </div>
      <div className="grid gap-3 stagger">
        {TILES.map(([g, to, title, sub, Icon, grad]) => {
          const d = ov?.games?.[g];
          return (
            <Link key={g} to={to} data-testid={`skill-tile-${g}`} className="tap group lux-card rounded-3xl p-4 flex items-center gap-4 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-rose-100">
              <span className={`relative w-14 h-14 rounded-2xl bg-gradient-to-br ${grad} text-white flex items-center justify-center shrink-0 shadow-lg shadow-rose-200 group-hover:scale-105 transition-transform`}>
                <Icon className="w-7 h-7" strokeWidth={2.2} />
                <span className="absolute inset-0 rounded-2xl bg-gradient-to-b from-white/35 to-transparent" />
              </span>
              <span className="flex-1 min-w-0">
                <span className="block font-display font-extrabold text-slate-900 leading-tight">{title}</span>
                <span className="block text-xs text-slate-500 mt-0.5">{sub}</span>
                {d && <span className="mt-1.5 flex flex-wrap gap-1.5">
                  <span className={`px-2 h-6 inline-flex items-center rounded-full text-[11px] font-extrabold ${d.plays_left ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-500"}`} data-testid={`skill-tile-${g}-left`}>{d.plays_left ? `bis +${d.tiers[0].points} · ${d.plays_left}× heute` : "Heute gewertet ✓"}</span>
                  {d.best != null && <span className="px-2 h-6 inline-flex items-center rounded-full bg-rose-50 text-rose-700 text-[11px] font-bold">Best: {d.best} {d.unit}</span>}
                </span>}
              </span>
              <ChevronRight className="w-5 h-5 text-rose-400 group-hover:translate-x-1 transition-transform" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
